export default __webpack_public_path__ + "static/media/img1.79da6669.jpg";